import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Home from './pages/home';
import QR from './pages/QrPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/QR" element={<QR />} />
      </Routes>
      <SpeedInsights />
    </Router>
  );
}

export default App;
